export const TABLE_DATA_CONFIG = {
  gridConfig: [
    { label: '编码',
      prop: 'code' },
    { label: '中文名',
      prop: 'name',
      render: (h, params) => {
        return h('input', {
          class:'el-input__inner',
          domProps: {
            value: params.row.name
          },
          on: {
            input: function(event) {
              params.row.name = event.target.value
            }
          }
        })
      }
    }
  ],
  dialogConfig: {
    width: '50%',
    labelWidth: '120px'
  },
  queryConfig: [
    { span: 12,
      label: '代码',
      prop: 'code',
      type: 'text',
      data: []
    },
    { span: 12,
      label: '名称',
      prop: 'name',
      type: 'text',
      data: []
    }
  ],
  // crud的模态框表单配置，可配置表单类型，验证规则，是否必填,col-span布局可通过span参数配置
  formConfig: [
    { span: 24,
      label: '代码',
      prop: 'code',
      type: 'text',
      rules:
      { required: true,
        message: '请输入表编码',
        trigger: 'blur'
      },
      data: []
    },
    { span: 24,
      label: '名称',
      prop: 'name',
      type: 'text',
      rules:
      { required: true,
        message: '请输入表名称',
        trigger: 'blur'
      },
      data: []
    }
  ],
  gridTopBtnConfig: [{
    'name': '新建',
    'type': null,
    'classify': 'create',
    'index': 0,
    'location': 'top',
    'roles': [],
    'modelId': null,
    'actionUrl': ''
  }, {
    'name': '重置',
    'type': null,
    'classify': 'reset',
    'index': 1,
    'location': 'top',
    'roles': [],
    'modelId': null,
    'actionUrl': ''
  }, {
    'name': '导出',
    'type': null,
    'classify': 'export',
    'index': 2,
    'location': 'top',
    'roles': [],
    'modelId': null,
    'actionUrl': ''
  }],
  //
  gridBtnConfig: [
    {
      'name': '删除',
      'type': null,
      'classify': 'delete',
      'index': 1,
      'location': 'grid',
      'roles': [],
      'modelId': null,
      'actionUrl': ''
    },
    {
      emitName:'stragetyonfig',
      'name': '配置',
      'type': null,
      'classify': 'stragetyonfig',
      'index': 1,
      'location': 'grid',
      'roles': [],
      'actionUrl': ''
    }
  ],
  // 表单基础数据类型，需要预先赋值
  formModel: {
    'id': '',
    'code': '',
    'name': ''
  },
  queryModel: {
  }
}



// WEBPACK FOOTER //
// ./src/components/generator/createCode/config/table.js